import React, { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import translationsTR from "../translations/tr.json";
import translationsEN from "../translations/en.json";

export const LanguageContext = createContext();

const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(Cookies.get("lang") || "tr");
  const translations = language === "tr" ? translationsTR : translationsEN;

  const changeLanguage = (lang) => {
    setLanguage(lang);
    Cookies.set("lang", lang, { expires: 7 });
  };

  useEffect(() => {
    const cookieLang = Cookies.get("lang");
    if (cookieLang) {
      setLanguage(cookieLang);
    } else {
      Cookies.set("lang", "tr", { expires: 7 });
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, translations, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;